'use client';

import { LinkRules } from '@platejs/link';
import { LinkPlugin } from '@platejs/link/react';

import { LinkElement } from '@/components/ui/link-node';

/** Field-tier links: render + markdown/paste autolink (no WYSIWYG insert button). */
export const FieldLinkKit = [
  LinkPlugin.configure({
    options: {
      triggerFloatingLinkHotkeys: '',
    },
    inputRules: [
      LinkRules.markdown(),
      LinkRules.autolink({ variant: 'paste' }),
    ],
    render: {
      node: LinkElement,
    },
  }),
];
